import React, { useState } from "react";
import "./main.css";
import Menu from "../menu/menu";
import TextMain from "../Texto Principal/textoMain";
import icone from "../../../assets/mobile/logo.png";

// Importando os componentes específicos
import Indisponivel from "../indisponivel/indisponivel";
import Page01 from "../botoes/Botoesmobile-page01";
import Agenda from "../Agendamento/agendamento";
import Sobre from "../TelaSobre/sobre";

import Logout from "../logout/logout";

const Main = () => {
    const [paginaAtual, setPaginaAtual] = useState("Térreo");

    const renderizarComponente = () => {
        switch (paginaAtual) {
            case "Térreo":
                return <Page01 />;
            case "Gestao":    
                return <Indisponivel />;
            case "Agendamentos":  
                return <Agenda />;
            case "Histórico":  
                return <Indisponivel />;
            case "Sobre":
                return <Sobre />;
            case "Sair":
                return <Logout />;
            default:
                return null;
        }
    };

    return (
        <div className="content-mobile">
            <div className="campoLogo-mobile">
                <img src={icone} alt="Logo" id="logo-mobile" />
            </div>
            <Menu trocarPagina={setPaginaAtual} paginaAtual={paginaAtual} />
            <TextMain />
            {renderizarComponente()}
        </div>
    );
};

export default Main;